import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import FlowChartEmbed from '../components/Flowchart/FlowChartEmbed';
import styles from './FlowchartViewPage.module.css';

export default function FlowchartViewPage() {
  const { slug } = useParams<{ slug: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [flowchart, setFlowchart] = useState<any>(null);

  useEffect(() => {
    async function fetchFlowchart() {
      try {
        setLoading(true);
        const response = await api.get(`/flowcharts/${slug}`);
        setFlowchart(response.data);
      } catch (err: any) {
        setError(err.message || 'Failed to load flowchart');
      } finally {
        setLoading(false);
      }
    }

    if (slug) {
      fetchFlowchart();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingText}>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorCard}>
          <h2 className={styles.errorTitle}>Error</h2>
          <p className={styles.errorMessage}>{error}</p>
          <Link to="/flowcharts" className={styles.backButton}>
            Back to Flowcharts
          </Link>
        </div>
      </div>
    );
  }

  if (!flowchart) {
    return (
      <div className={styles.container}>
        <div className={styles.notFound}>
          <h2 className={styles.notFoundTitle}>Flowchart Not Found</h2>
          <Link to="/flowcharts" className={styles.backButton}>
            Back to Flowcharts
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>{flowchart.title}</h1>
          <div className={styles.meta}>
            <span className={styles.metaItem}>Folder: {flowchart.folder_path}</span>
            <span className={styles.metaItem}>
              Updated: {new Date(flowchart.updated_at).toLocaleDateString()}
            </span>
            {flowchart.is_private && (
              <span className={styles.privateBadge}>Private</span>
            )}
          </div>
        </div>
        <div className={styles.actions}>
          <Link
            to={`/flowcharts/edit/${flowchart.slug}`}
            className={styles.editButton}
          >
            Edit Flowchart
          </Link>
          <Link
            to="/flowcharts"
            className={styles.backButtonSecondary}
          >
            Back to List
          </Link>
        </div>
      </div>

      <div className={styles.chartContainer}>
        {slug && <FlowChartEmbed slug={slug} />}
      </div>
    </div>
  );
}
